<template>
    <mw-dialog  size="" title="跳至普通节点" :footerButton="footerButton" ref="dialog">
      <div style="padding: 10px;">
        <el-form :model="editingForm" label-width="150px" :rules="editingRule" ref="editingFormRef">
          <el-form-item label="所在节点" prop="oneNode">
            <el-select  v-model="editingForm.oneNode" style="width:100%">
              <el-option
                v-for="item in unfinishedTaskQueue"
                :key="item.id"
                :label="`${item.name||''}-${item.department||''}-${item.candidateName||''}`.replace(/-$|^-|--/g, '')"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="送至节点" prop="twoNode">
            <el-select  v-model="editingForm.twoNode" style="width:100%">
              <el-option
                v-for="item in nextFlowList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="办理人" prop="twoMan">
            <all-man-select v-model="editingForm.twoMan"/>
          </el-form-item>
        </el-form>
      </div>
    </mw-dialog>
</template>

<script>
import api from "@/common/api/maintain";
import AllManSelect from "../common/allManSelect";
export default {
  data() {
    return {
      editingForm: {
        oneNode: "", // taskId
        twoNode: "", // flowId
        twoMan: []
      },
      unfinishedTaskQueue: [],
      nextFlowList: [],
      editingRule: {
        oneNode: [{ required: true, message: "请选择完成节点" }],
        twoNode: [{ required: true, message: "请选择送至节点" }],
        twoMan: [
          {
            validator: (rule, value, callback) => {
              if (!value || !value.length) {
                callback("请选择办理人");
              } else {
                callback();
              }
            }
          }
        ]
      },
      footerButton: [
        {
          label: "确定",
          func: async () => {
            if (await this.mwRef("editingFormRef").validate()) {
              const taskId = this.editingForm.oneNode;
              const items = [];
              this.editingForm.twoMan.forEach(d => {
                items.push({
                  group: d.departmentId,
                  users: [{ id: d.id }]
                });

                /*if (d.type === "U") {
                  searchScope: {
                    for (let i = 0; i < items.length; i++) {
                      if (items[i].group === d.parentId) {
                        items[i].users.push({ id: d.id });
                        break searchScope;
                      }
                    }
                    // if no avaliable item found, create one
                    items.push({
                      group: d.parentId,
                      users: [{ id: d.id }]
                    });
                  }
                } else {
                  let users = [],
                    identities = [];
                  for (let iden of d.identities || []) {
                    if (iden.type == "U") {
                      users.push({ id: iden.id });
                    } else {
                      identities.push({ id: iden.id });
                    }
                  }
                  items.push({
                    group: d.id,
                    users,
                    identities
                  });
                }*/
              });
              const params = {
                $identityItems: items,
                formOpenSource:
                  "pc:company-index.flowInterfering.jump2normalFlow",
                actionDescription: '跳至普通节点'
              };

              if ((await api.specify(taskId, this.editingForm.twoNode, params)).success) {
                this.mwMsg("跳转成功");
                this.$emit('updateTable');
                this.mwRef("dialog").hide();
              }
            }
          }
        }
      ],

      applicationId: "",
      businessId: "",
      batchId:'',
      moduleId: ""
    };
  },
  computed: {},
  methods: {
    async action({ applicationId, businessId, moduleId, batchId, processDefinitionId }) {
      this.applicationId = applicationId;
      this.businessId = businessId;
      this.batchId = batchId;
      this.moduleId = moduleId;
      this.processDefinitionId = processDefinitionId;
      this.editingForm = {
        oneNode: "",
        oneMan: "",

        twoNode: "",
        twoMan: []
      };
      this.mwRef("dialog").show();

      this.getUnfinishedTaskQueue();
      this.getNormalTaskActivities();
    },

    async getUnfinishedTaskQueue() {
      this.unfinishedTaskQueue = [];
      //默认true
      let undrafted = (window.$Env && $Env.specialContainDrafts===true) ? false : true;
      this.unfinishedTaskQueue =
        (await api.listUnfinishedTask(this.batchId, { type: 1, unfinished:true, undrafted:undrafted  })).result ||
        [];
      // must update it manully
      if (!this.editingForm.oneNode && this.unfinishedTaskQueue[0]) {
        this.editingForm = {
          ...this.editingForm,
          oneNode: this.unfinishedTaskQueue[0].id
        };
      }
    },

    async getNormalTaskActivities() {
      this.nextFlowList = [];
      this.nextFlowList = (await api.getNormalTaskActivities({
        appId: this.applicationId,
        processDefinitionId: this.processDefinitionId
      })).result;
      // must update it manully, select the first option like the browser default action
      if (!this.editingForm.twoNode && this.nextFlowList[0]) {
        this.editingForm = {
          ...this.editingForm,
          twoNode: this.nextFlowList[0].id
        };
      }
    }
  },

  components: {
    AllManSelect
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/flowInterfering/actions/jump2normalFlow.vue